import React from 'react';
import PropTypes from 'prop-types';

import Filter, { FilterModal, FilterSection } from './Filter';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';

const DivisionTypeFilter = (props) => {
    const {
        clearFilters,
        filters,
        filterInputs,
        handleFilterClick,
        filterModal,
        closeModals,
        handleFilterSubmit,
        handleFilterUpdate,
        mobileOnly,
        desktopOnly,
        searchTypes,
        'data-testid': dataTestId,
    } = props;

    const handleCheckboxChange = (value) => {
        const currentFilters = filterInputs.divisionTypes;
        handleFilterUpdate({
            divisionTypes: {
                ...currentFilters,
                [value]: !currentFilters[value],
            },
        });
    };

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'divisionType'}
                handleFilterClick={handleFilterClick}
                isActive={(filters?.divisionTypes && Object.values(filters.divisionTypes).indexOf(true) > -1) || filterModal === 'divisionType'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Type
            </Filter>
            {filterModal === 'divisionType' && (
                <FilterModal
                    title={'Division Type'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('divisionType')}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`divisionTypes`}
                            filterInputs={filterInputs}
                            filtersPropName={`divisionTypes`}
                            onChange={handleCheckboxChange}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

DivisionTypeFilter.propTypes = {
    filters: PropTypes.instanceOf(Object).isRequired,
    filterInputs: PropTypes.instanceOf(Object).isRequired,
    searchTypes: PropTypes.instanceOf(Object).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    clearFilters: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};
DivisionTypeFilter.defaultProps = {
    handleFilterClick: () => { },
    handleFilterSubmit: () => { },
    clearFilters: () => { },
    closeModals: () => { },
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': undefined,
};

export default DivisionTypeFilter;
